import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppService } from '../app.service';
import { HttpClient, HttpParams } from '@angular/common/http';


@Injectable({
  providedIn: 'root'
})
export class ImageService {

  readonly #appService = inject(AppService);
  readonly #httpClient = inject(HttpClient);
  private baseUrl: string = this.#appService.utilsUrls.apiUrl;

  downloadImages(modelId: number, colorIds?: Array<number>, sizeGroupIds?: Array<number>): Observable<Blob> {
    let params = new HttpParams().set('modelId', modelId.toString());
    
    if (colorIds && colorIds.length > 0) {
      params = params.append('colorIds', colorIds.join('-'));
    }
    
    if (sizeGroupIds && sizeGroupIds.length > 0) {
      params = params.append('sizeGroupIds', sizeGroupIds.join('-'));
    }

    return this.#httpClient.get(`${this.baseUrl}/Company/DownloadImages`, {
      params: params,
      responseType: 'blob'
    });
  }

  downloadImagesByShotIds(shotIds: Array<number>): Observable<Blob> {
    let params = new HttpParams();
    
      params = params.append('shotIds', shotIds.join('-'));

    return this.#httpClient.get(`${this.baseUrl}/Company/DownloadImagesByShotIds`, {
      params: params,
      responseType: 'blob'
    });
  }

}
